export const isDraggable = (
  e: MouseEvent | TouchEvent,
  boundingBox?: DOMRect
): boolean => {
  const currentPoint = "touches" in e ? e.changedTouches[0] : e;
  const left = boundingBox?.left ?? 0;
  const right = boundingBox?.right ?? 0;
  const top = boundingBox?.top ?? 0;
  const bottom = boundingBox?.bottom ?? 0;
  if (
    currentPoint.clientX > left &&
    currentPoint.clientX < right &&
    currentPoint.clientY > top &&
    currentPoint.clientY < bottom
  ) {
    return true;
  }

  return false;
};
